<template>
  <a-layout-content class="vab-content">
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
  </a-layout-content>
</template>

<script>
  export default {
    name: 'VabContent',
  }
</script>

<style lang="less">
  @import url('@/styles/params.less');
  .fade-transform-leave-active,
  .fade-transform-enter-active {
    transition: all 0.2s;
  }

  .fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
  }

  .fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
  }

  .vab-content {
    min-height: calc(
      100vh - @app-header-height - @app-footer-height - @app-conetent-margin
        // -        @app-conetent-margin - @app-footer-height
    ) !important;
    // margin: @app-conetent-margin 0;
    position: relative;

    // FOR DEV
    // box-shadow: inset 0 0px 10px #fff;
    // background: yellowgreen;

    // .error-container {
    //   height: calc(
    //     100vh - @app-header-height - @vab-padding - @vab-padding - @vab-padding -
    //       @vab-padding - @vab-padding - @vab-margin
    //   ) !important;
    // }
  }
</style>
